import script from "./legoIconExtend.vue?vue&type=script&lang=js"
export * from "./legoIconExtend.vue?vue&type=script&lang=js"

import "./legoIconExtend.vue?vue&type=style&index=0&id=158f0c88&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-158f0c88"],['__file',"src/components/lego/extend/legoIconExtend/legoIconExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "158f0c88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('158f0c88', __exports__)) {
    api.reload('158f0c88', __exports__)
  }
  
}


export default __exports__